import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import styles from "./index.module.css";


export class PageDivider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }



    render() {

        return (
            <MDBox py={2} container>
                <div className={this.props.text ? styles.strike : styles.strike2}>
                    <span>
                        <MDTypography
                            variant={"subtitle2"}
                            textTransform={"uppercase"}
                            verticalAlign={"middle"}
                        >
                            {this.props.text?this.props.text:""}
                        </MDTypography>
                    </span>
                </div>
            </MDBox>
        )
    }
}

export default PageDivider;


PageDivider.defaultProps = {
    text: null,
}
